// src/main.js
//https://www.docs4.dev/posts/easy-bootstrap-5-integration-with-vue-3-step-by-step-guide
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from './plugins/axios'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom.css'
//import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
//import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
//import "bootstrap-icons";
//import { ref } from 'vue';



var app = createApp(App);

//app.config.globalProperties.isAuthenticated = false;
//app.config.globalProperties.loading = ref(false);
//app.config.globalProperties.imageBaseUrl = process.env.NODE_ENV === 'production' ? 'https://www.workshopix.com/u/workshopix/img/' : 'https://www.megakitap.test/u/site/img/';
app.config.globalProperties.apiServerRoot = process.env.NODE_ENV === 'production' ? '/ws/' : '/';
app.use(axios,{
    baseUrl: process.env.NODE_ENV === 'production' ? '/ws/api' : '/api',
});
app.use(router);
//app.use(BootstrapVue)
//app.use(BootstrapVueIcons)
//app.component('BIcon', BIcon)
//app.component('BIconArrowUp', BIconArrowUp)
//app.component('BIconArrowDown', BIconArrowDown)
//app.provide('bootstrap', bootstrap);
app.mount('#app');  

